import { Dayjs } from 'dayjs';

export function createProjectLoggingUrl(from: Dayjs, to: Dayjs) {
  return `${
    //@ts-ignore
    window.PROJECT_LOGGING_URL
  }#/?_a=(columns:!(Message,Level,EntryAssembly,Environment),filters:!(),index:'99577930-6dbc-11ee-839c-87d62e6b2df3',interval:auto,query:(language:kuery,query:'Customer:%20%22Alfa%20Accountants%22%20AND%20Project:%20%22MKB%20Nota%22'),sort:!(!('@timestamp',desc)))&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:'${from.toISOString()}',to:'${to.toISOString()}'))`;
}
